import React from 'react';
import { Card } from 'antd';

export default function About({ aboutInfo = { title: '', content: '' } }) {
  return (
    <div className="page-container">
      <Card title={aboutInfo.title || '关于'}>
        <div style={{ whiteSpace: 'pre-wrap' }}>{aboutInfo.content}</div>
      </Card>
    </div>
  );
}
